import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoOptionsModalCloseTrackingEvent } from "./tracking";

interface TrackUploadPhotoOptionsModalCloseFunction {
  (): void;
}

interface UseTrackUploadPhotoOptionsModalCloseFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoOptionsModalCloseFunction {
  (agrs: UseTrackUploadPhotoOptionsModalCloseFunctionArgs): TrackUploadPhotoOptionsModalCloseFunction;
}

const useTrackUploadPhotoOptionsModalClose: UseTrackUploadPhotoOptionsModalCloseFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoOptionsModalCloseTrackingEvent>();

  const trackUploadPhotoOptionsModalClose: TrackUploadPhotoOptionsModalCloseFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.UPLOAD_PHOTO_OPTIONS_MODAL_CLOSE,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, emitUserEvent, customerId, tradename, segment]);

  return trackUploadPhotoOptionsModalClose;
};

export { useTrackUploadPhotoOptionsModalClose };
